// File: app/src/components/workout/RepsDoneList.js
//
// Reps done on every set, on the completion screen (#144). The rest after a
// set is the in-session chance to correct it (#97), but some sets never get
// one: the last set of an exercise whose short rest was dropped, supersets,
// and the session's final set. This is the catch-all before the session is
// saved. One row per exercise; each set's figure opens the reps sheet.

import React from "react";

const RepsDoneList = ({ sets, onEdit }) => {
  if (!sets?.length) return null;

  // Exercises in the order they were first done, each with its sets in order.
  const rows = [];
  const byId = new Map();
  for (const set of sets) {
    if (!byId.has(set.nodeId)) {
      const row = { nodeId: set.nodeId, label: set.label, sets: [] };
      byId.set(set.nodeId, row);
      rows.push(row);
    }
    byId.get(set.nodeId).sets.push(set);
  }

  return (
    <section className="mb-4 text-left" aria-labelledby="reps-done-heading">
      <div className="mb-1.5 flex items-baseline justify-between gap-2">
        <h3 id="reps-done-heading" className="text-sm font-semibold">
          Reps done
        </h3>
        <span className="text-xs text-muted-foreground">Tap a set to change it</span>
      </div>
      <ul className="space-y-1">
        {rows.map((row) => (
          <li
            key={row.nodeId}
            className="flex items-start gap-3 rounded-md bg-surface px-3 py-1.5"
          >
            <span className="min-w-0 flex-1 break-words py-1 text-sm">{row.label}</span>
            <span className="flex shrink-0 flex-wrap justify-end gap-1">
              {row.sets.map((set) => {
                const changed = set.actual !== set.prescribed;
                return (
                  <button
                    key={set.index}
                    type="button"
                    onClick={() => onEdit(set)}
                    aria-label={`Change reps for ${set.label} set ${set.setNumber}: ${set.actual} reps`}
                    className={`min-w-[2.25rem] rounded-md border px-2 py-1 text-sm tabular-nums focus:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
                      changed
                        ? "border-primary/60 font-semibold text-foreground"
                        : "border-border text-muted-foreground hover:text-foreground"
                    }`}
                  >
                    {set.actual}
                  </button>
                );
              })}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default RepsDoneList;
